<template>
  <div class="zendesk">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>Zendesk <small v-if="!activeIntegration">(Inativo)</small></h4>
          </div>
          <div class="icon">
            <div v-if="activeIntegration">
              <font
                title="Configurações"
                size="6"
                color="black"
                @click.prevent="toogleUpdateIntegration()">
                <i class="ik ik-settings" />
              </font>
            </div>
            <div v-else>
              <font
                title="Configurações"
                size="6"
                color="gray">
                <i class="ik ik-settings" />
              </font>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="zendesk"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com Zendesk?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-lg modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Configurar Zendesk</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ErrorAlert :error="error" />
            <div class="form-group row">
              <label
                for="zendeskSubdomain"
                class="col-sm-4 col-form-label">Subdomínio</label>
              <div class="col-sm-8">
                <div class="input-group">
                  <span class="input-group-prepend">
                    <span class="input-group-text">https://</span>
                  </span>
                  <input
                    id="zendeskSubdomain"
                    ref="zendeskSubdomain"
                    type="text"
                    class="form-control"
                    tabindex="1"
                    v-model="subdomain">
                  <span class="input-group-append">
                    <span class="input-group-text">.zendesk.com</span>
                  </span>
                </div>
              </div>
            </div>
            <div v-if="isValidUrl">
              <p class="text-center">
                Para gerar/copiar seu Token
                <a
                  class="link"
                  :href="`https://${subdomain}.zendesk.com/agent/admin/api/settings`"
                  target="_blank">
                  clique aqui
                </a>
              </p>
              <div class="form-group row">
                <label
                  for="zendeskToken"
                  class="col-sm-4 col-form-label">Token de acesso</label>
                <div class="col-sm-8">
                  <input
                    id="zendeskToken"
                    type="text"
                    class="form-control"
                    tabindex="2"
                    v-model="token">
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="email"
                  class="col-sm-4 col-form-label">Email Zendesk</label>
                <div class="col-sm-8">
                  <input
                    id="email"
                    type="text"
                    class="form-control"
                    tabindex="3"
                    v-model="email">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Usuário</label>
                <div class="col-sm-8">
                  <select
                    class="form-control"
                    id="user"
                    tabindex="4"
                    v-model="user">
                    <option
                      v-for="option in usersOptions"
                      :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">{{ labelSubmit }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração com a Zendesk CRM atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Zendesk removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialZendesk"
      title="Tutorial Zendesk"
      video-url="https://www.youtube.com/embed/9_HAf39YopM" />
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'IntegrationZendesk',
  components: {
    TutorialVideoModal
  },
  data () {
    return {
      error: null,
      integration: null,
      configReady: false,
      email: this.$store.state.auth.user.email,
      subdomain: null,
      token: null,
      user: null,
      usersOptions: [],
      runningLoadUsers: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
    })
  },
  methods: {
    loadIntegration () {
      return loopback
        .get(`/integrations?filter[where][gateway]=zendesk`)
        .then(integrations => {
          this.integration = integrations.pop()
          if (this.integration && this.integration.metadata) {
            this.subdomain = this.integration.metadata.subdomain
            this.token = this.integration.metadata.token
            this.email = this.integration.metadata.email
            this.user = this.integration.metadata.user
          }
        })
        .catch(err => { this.$emit('onError', err) })
    },
    saveIntegration () {
      if (this.subdomain && this.token && this.configReady) {
        this.error = null
        const integrationParams = {
          gateway: 'zendesk',
          webhook: true,
          webhookConstraint: {
            metadata: {
              api4comGateway: 'zendesk'
            }
          },
          metadata: {
            subdomain: this.subdomain,
            token: this.token,
            email: this.email,
            user: this.user,
            webhookUrl: `${process.env.API4COM_BASE_URL_API}${process.env.API4COM_VERSION_API}/integrations/webhook`,
            webhookVersion: 'v1.4',
            webhookTypes: ['channel-hangup']
          }
        }
        if (this.integration) integrationParams.id = this.integration.id
        loopback
          .patch('/integrations', integrationParams)
          .then(integration => {
            this.integration = integration
            $(this.$refs.updateIntegration).modal('hide')
            $(this.$refs.successIntegration).modal('show')
          })
          .catch(err => {
            this.error = err
            // TEL-2243: o `friendly` do interceptor ja resolve `details.messages` pelo
            // FIELD_MESSAGES, mantem em pt-BR o que o backend ja manda traduzido e nomeia
            // o campo quando nao ha texto proprio. Montar `lines` aqui devolvia o texto do
            // LoopBack em ingles e ainda sobrescrevia a traducao.
          })
      } else {
        this.error = {
          message: 'Subdomínio, Email e Token são obrigatórios'
        }
      }
    },
    toogleIntegration (event) {
      if (event.value === true) {
        setTimeout(_ => {
          this.$refs.zendeskSubdomain.focus()
        }, 500)
        $(this.$refs.updateIntegration).modal('show')
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.subdomain = null
          this.token = null
          this.email = null
          this.user = null
          this.error = null
          this.configReady = false
          this.usersOptions = []
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    loadUsers () {
      if (this.subdomain && this.email && this.token && !this.runningLoadUsers) {
        this.runningLoadUsers = true
        return loopback
          .get(`/integrations/zendesk/users?subdomain=${this.subdomain}&email=${this.email}&token=${this.token}`)
          .then(users => {
            if (users && users.length > 0) {
              const zendeskUser = users.filter(u => u.email === this.email)
              if (zendeskUser && zendeskUser[0]) {
                this.user = zendeskUser[0].id
              } else if (users[0]) {
                this.user = users[0].id
              }
              this.usersOptions = []
              users.forEach(user => {
                this.usersOptions.push({
                  value: user.id,
                  text: `${user.name} (${user.email})`
                })
              })
              this.configReady = true
              this.error = null
            } else {
              this.configReady = false
              this.error = {
                message: 'Subdomínio, Email ou Token inválidos'
              }
            }
          })
          .catch(err => {
            this.usersOptions = []
            this.configReady = false
            if (err.statusCode === 429) this.error = err
            else {
              this.error = {
                message: 'Subdomínio, Email ou Token inválidos'
              }
            }
          })
          .finally(_ => {
            this.runningLoadUsers = false
          })
      }
    },
    openTutorial () {
      this.$refs.tutorialZendesk.open()
    }
  },
  computed: {
    activeIntegration () {
      return this.integration && this.integration.gateway === 'zendesk'
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    },
    isValidUrl () {
      return this.subdomain && this.subdomain.length > 2
    }
  },
  watch: {
    token: function (token) {
      if (token && token.length >= 40) this.loadUsers()
    },
    email: function (value) {
      if (value) {
        this.email = value.replace(/[^A-Za-z0-9|_.@+-]/, '').toLowerCase()
        // eslint-disable-next-line
        const regexToValidateEmail = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        if (this.email && regexToValidateEmail.test(this.email)) this.loadUsers()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/Zendesk.vue